module.exports = __webpack_public_path__ + "img/multi-doboz-icon-gold.a995e7a4.svg";